import { useLocationQuery } from '@web/helpers/hooks';
import { useLocation } from 'react-router';

export const useIsStaff = () => {
  const { pathname: path } = useLocation();
  const query = useLocationQuery();
  return path.startsWith('/staff-timesheets') || path.startsWith('/staff-time-clocks') || query.get('staff') === 'true';
};
